import {callAPI} from '@/store/utils';

export default {
  namespaced: true,
  state: {
    bankAndAggregators: [],
    aggregators: [],
  },
  getters: {
    displayedBanks(state) {
      return [...state.bankAndAggregators, ...state.aggregators];
    },
  },
  mutations: {
    setBanksAndAggreagtors(state, data) {
      state.bankAndAggregators =
        data.result && data.result.length ? Object.freeze(data.result) : [];
    },
    setAllBankAggregators(state, data) {
      state.aggregators =
        data.result && data.result.length ? Object.freeze(data.result) : [];
    },
  },
  actions: {
    async actionGetRedirectUrl(_, params) {
      localStorage.setItem('BANK_NAME', params?.bankName?.name);
      const res = await callAPI('POST', 'getRedirectUrl', {...params});
      return res.result;
    },
    async actionGetAccessToken(_, params) {
      const res = await callAPI('POST', 'getProviderToken', {...params});
      return res.result;
    },
    async actionGetBankAccounts(_, params) {
      const res = await callAPI('POST', 'getBankAccounts', {...params});
      return res;
    },
    async actionGetBankAccountTransactions(_, params) {
      const res = await callAPI('POST', 'getBankTransactions', params);
      return res.result;
    },
    async getDataAfterSuccess(_, params) {
      const res = await callAPI(
        'POST',
        'getDataAfterSuccess',
        params,
        false,
        false,
      );
      return res;
    },
    async isGetDataAfterSuccessFinish(_, params) {
      const res = await callAPI('POST', 'isGetDataAfterSuccessFinish', params);
      return res.result;
    },
    async actionCompleteBridgeSync(_, params) {
      const res = await callAPI(
        'POST',
        'completeBridgeSync',
        params,
        false,
        60,
      );
      return res;
    },
    async actionGetBanksAndAggreagtors({commit}, params) {
      const res = await callAPI('GET', 'getBanksAndAggreagtors', params);
      commit('setBanksAndAggreagtors', res);
      return res;
    },
    async actionGetAllBankAggregators({commit}, params) {
      const res = await callAPI('POST', 'getAllBankAggregators', params);
      commit('setAllBankAggregators', res);
      return res;
    },
  },
};
